import axios from 'axios';
import { useEffect } from 'react';
import useRefreshToken from './useRefreshToken';
//import useAuth from './useAuth';

const baseURL = process.env.REACT_APP_API_BASE_URL;

export const axiosPrivate = axios.create({
    baseURL: baseURL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true       // Ensures cookies are sent with requests
});

export const useAxiosPrivate = () => {
    const refresh = useRefreshToken();
    //const { auth } = useAuth();

    useEffect(() => {

        //console.log("useAxiosPrivate.js > useEffect > START");
        // Request interceptor

        const requestIntercept = axiosPrivate.interceptors.request.use(
            config => {

                // No need to set the Authorization header manually
                //if (!config.headers['Authorization']) {
                //config.headers['Authorization'] = `Bearer ${auth?.accessToken}`;
                //}

                //console.log("useAxiosPrivate.js > Request with Authorization header: ", config.headers['Authorization']);

                return config;
            },
            (error) => Promise.reject(error)
        );

        // Response interceptor
        const responseIntercept = axiosPrivate.interceptors.response.use(
            (response) => response,
            async (error) => {
                const prevRequest = error?.config;

                // If the error is 403 (Forbidden) and the request hasn't been retried yet
                if (error?.response?.status === 403 && !prevRequest?.sent) {
                    prevRequest.sent = true;                  // Mark the request as retried

                    try {
                        // Refresh the access token using the refresh token
                        const newAccessToken = await refresh();

                        // Retry the request with the new access token
                        prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                        return axiosPrivate(prevRequest);
                    } catch (refreshError) {
                        // If refreshing the token fails, log the user out
                        console.error("Failed to refresh token:", refreshError);
                        return Promise.reject(refreshError);
                    }
                }

                // For other errors, reject the promise
                return Promise.reject(error);
            }
        );

        // Cleanup interceptors when the component unmounts
        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate.interceptors.response.eject(responseIntercept);
        }
    }, [refresh]);

    return axiosPrivate;
}

export default useAxiosPrivate;
